import { IncomeFilters, EarnData } from './types';
import { FilterOption } from '../../../components/ui';

export const DEFAULT_FILTERS: IncomeFilters = {
  account: '',
  campaign: '',
  grouping: 'day',
  limit: '',
  source: '',
};

export const DEFAULT_PAGE_SIZE = 10;
export const SEARCH_DEBOUNCE_DELAY = 500;

export const getGroupingOptions = (t: (key: string) => string): FilterOption[] => [
  { key: 'day', label: t('partner.revshare.income.filters.groupingDayShort') || 'дни' },
  { key: 'week', label: t('partner.revshare.income.filters.groupingWeekShort') || 'недели' },
  { key: 'month', label: t('partner.revshare.income.filters.groupingMonthShort') || 'месяца' },
];

export const getLimitOptions = (t: (key: string) => string): FilterOption[] => [
  { key: 'all', label: t('partner.revshare.income.filters.limitAll') || 'Все' },
  { key: '30days', label: t('partner.revshare.income.filters.limit30days') },
  { key: '90days', label: t('partner.revshare.income.filters.limit90days') },
  { key: 'year', label: t('partner.revshare.income.filters.limitYear') },
];

export const getSourceOptions = (t: (key: string) => string): FilterOption[] => [
  { key: 'all', label: t('partner.revshare.income.filters.sourceAll') || 'Все источники' },
  { key: 'cpl', label: 'CPL' },
  { key: 'revshare', label: 'RevShare' },
];

export const getTableColumns = (t: (key: string) => string) => [
  { name: t('partner.revshare.income.table.source'), key: 'source' },
  { name: t('partner.revshare.income.table.date'), key: 'date' },
  { name: t('partner.revshare.income.table.fans'), key: 'fans' },
  { name: t('partner.revshare.income.table.earnings'), key: 'earnings' },
];

export const getCampaignTypeColors = () => ({
  cpl: { bg: 'bg-[rgba(120,40,200,0.2)]', text: 'text-accent' },
  ref_share: { bg: 'bg-[rgba(120,40,200,0.2)]', text: 'text-accent' },
  // ref_share: { bg: 'bg-[rgba(0,111,238,0.2)]', text: 'text-partner' },
});

// Mock data for testing - will be removed when API is connected
export const MOCK_EARNS: EarnData[] = [
  {
    date: '2025-09-10',
    compaign_type: 'cpl',
    total_amount: 0,
    total_subscribers: 0,
  },
  {
    date: '2025-09-10',
    compaign_type: 'ref_share',
    total_amount: 12.99,
    total_subscribers: 5,
  },
  {
    date: '2025-09-09',
    compaign_type: 'ref_share',
    total_amount: 0,
    total_subscribers: 0,
  },
  {
    date: '2025-09-09',
    compaign_type: 'ref_share',
    total_amount: 0,
    total_subscribers: 34,
  },
  {
    date: '2025-09-08',
    compaign_type: 'cpl',
    total_amount: 0,
    total_subscribers: 0,
  },
  {
    date: '2025-09-08',
    compaign_type: 'cpl',
    total_amount: 0,
    total_subscribers: 88,
  },
  {
    date: '2025-09-07',
    compaign_type: 'cpl',
    total_amount: 450,
    total_subscribers: 12,
  },
  {
    date: '2025-09-06',
    compaign_type: 'cpl',
    total_amount: 120,
    total_subscribers: 0,
  },
  {
    date: '2025-09-05',
    compaign_type: 'ref_share',
    total_amount: 111,
    total_subscribers: 0,
  },
  {
    date: '2025-09-04',
    compaign_type: 'ref_share',
    total_amount: 120,
    total_subscribers: 67,
  },
];
